<template>
  <div id="wind-hazard-index">
    <router-view></router-view>
  </div>
</template>
<script>
import { createSurvey, updateSurvey } from "@/api/survey.api";
import { mapActions, mapState } from "vuex";
export default {
  name: 'WindHazardIndex',
  props: {},
  data() {
    return {};
  },
  beforeRouteLeave(to, from, next) {
    // if (navigator.onLine) this.$_saveDataToCould();
    next();
  },
  mounted() { },
  computed: {
    ...mapState({
      windHazardSurvey: (state) => state.Surveys.windHazard,
      user: (state) => state.User.user,
    }),
  },
  methods: {
    ...mapActions({
      updateSurvey: "Surveys/UPDATE_WIND_HAZARD",
    }),
    $_saveDataToCould() {
      if (this.windHazardSurvey) {
        if (this.windHazardSurvey.id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this.windHazardSurvey),
            },
          };
          updateSurvey(this.windHazardSurvey.id, payload)
            .then((res) => { })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        } else {
          const payload = {
            title: `${this.user.slug}-WindHazard`,
            author: this.user.id,
            status: "publish",
            tags: [38],
            content: `${this.user.slug}-WindHazard`,
            fields: {
              survey_data: JSON.stringify(this.windHazardSurvey),
            },
          };

          createSurvey(payload)
            .then((res) => {
              const surveyData = JSON.parse(res.data.acf.survey_data);
              surveyData.id = res.data.id;
              this.updateSurvey(surveyData);
            })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#wind-hazard-index {
  max-width: 100vw;
  overflow-x: hidden !important;
  /* max-width: 768px; */

}
</style>
<style lang="scss">
#wind-hazard-index {
  .app-form {
    max-width: 768px;
    margin: auto;
  }
}
</style>